/*
 * Icones do painel.
 *
 * Desenhados aqui, e nao vindos de uma biblioteca, porque sao doze: instalar um
 * pacote de mil icones para usar doze cobra manutencao e peso de bundle sem dar
 * nada em troca.
 *
 * Todos no mesmo desenho — traço de 1.5, cantos e pontas arredondados, grade de
 * 24 — para nao parecerem recortados de lugares diferentes.
 */
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement>;

function Base({ children, ...props }: Props) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      {children}
    </svg>
  );
}

export function IconDashboard(props: Props) {
  return (
    <Base {...props}>
      <rect x="3" y="3" width="7" height="9" rx="1.5" />
      <rect x="14" y="3" width="7" height="5" rx="1.5" />
      <rect x="14" y="12" width="7" height="9" rx="1.5" />
      <rect x="3" y="16" width="7" height="5" rx="1.5" />
    </Base>
  );
}

export function IconRouter(props: Props) {
  return (
    <Base {...props}>
      <rect x="3" y="13" width="18" height="8" rx="2" />
      <path d="M7 17h.01M11 17h.01" />
      <path d="M12 10V7" />
      <path d="M8.5 6a5 5 0 0 1 7 0" />
      <path d="M6 3.5a9 9 0 0 1 12 0" />
    </Base>
  );
}

export function IconBuilding(props: Props) {
  return (
    <Base {...props}>
      <path d="M4 21V6a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v15" />
      <path d="M14 10h4a2 2 0 0 1 2 2v9" />
      <path d="M3 21h18" />
      <path d="M8 8h2M8 12h2M8 16h2M17 14h.01M17 17h.01" />
    </Base>
  );
}

export function IconMegaphone(props: Props) {
  return (
    <Base {...props}>
      <path d="M3 11v2a1 1 0 0 0 1 1h2l5 4V6L6 10H4a1 1 0 0 0-1 1Z" />
      <path d="M15 9a4 4 0 0 1 0 6" />
      <path d="M18 6.5a8 8 0 0 1 0 11" />
    </Base>
  );
}

export function IconUsers(props: Props) {
  return (
    <Base {...props}>
      <circle cx="9" cy="8" r="3.25" />
      <path d="M3 20a6 6 0 0 1 12 0" />
      <path d="M16.5 5.5a3.25 3.25 0 0 1 0 6" />
      <path d="M18 14.5a6 6 0 0 1 3 5.5" />
    </Base>
  );
}

export function IconDocument(props: Props) {
  return (
    <Base {...props}>
      <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8Z" />
      <path d="M14 3v5h5" />
      <path d="M9 13h6M9 17h4" />
    </Base>
  );
}

export function IconSignal(props: Props) {
  return (
    <Base {...props}>
      <circle cx="12" cy="12" r="2" />
      <path d="M8.5 8.5a5 5 0 0 0 0 7M15.5 8.5a5 5 0 0 1 0 7" />
      <path d="M5.5 5.5a9 9 0 0 0 0 13M18.5 5.5a9 9 0 0 1 0 13" />
    </Base>
  );
}

export function IconChart(props: Props) {
  return (
    <Base {...props}>
      <path d="M4 20V4" />
      <path d="M4 20h16" />
      <path d="M8 20v-6M12.5 20V9M17 20v-9" />
    </Base>
  );
}

export function IconPlug(props: Props) {
  return (
    <Base {...props}>
      <path d="M9 3v5M15 3v5" />
      <path d="M6 8h12v3a6 6 0 0 1-6 6 6 6 0 0 1-6-6Z" />
      <path d="M12 17v4" />
    </Base>
  );
}

export function IconShield(props: Props) {
  return (
    <Base {...props}>
      <path d="M12 3l7 3v5.5c0 4.4-3 8.2-7 9.5-4-1.3-7-5.1-7-9.5V6Z" />
      <path d="M9.5 12l1.8 1.8 3.4-3.6" />
    </Base>
  );
}

export function IconHistory(props: Props) {
  return (
    <Base {...props}>
      <path d="M3.5 10a8.5 8.5 0 1 1 1.2 6" />
      <path d="M3 20v-4.5h4.5" />
      <path d="M12 7.5V12l3 1.8" />
    </Base>
  );
}

export function IconMenu(props: Props) {
  return (
    <Base {...props}>
      <path d="M4 7h16M4 12h16M4 17h16" />
    </Base>
  );
}

export function IconClose(props: Props) {
  return (
    <Base {...props}>
      <path d="M6 6l12 12M18 6 6 18" />
    </Base>
  );
}

export function IconLogout(props: Props) {
  return (
    <Base {...props}>
      <path d="M15 4h2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-2" />
      <path d="M10 8l-4 4 4 4" />
      <path d="M6 12h9" />
    </Base>
  );
}

export function IconLock(props: Props) {
  return (
    <Base {...props}>
      <rect x="4.5" y="10" width="15" height="10" rx="2" />
      <path d="M8 10V7a4 4 0 0 1 8 0v3" />
    </Base>
  );
}

export function IconChat(props: Props) {
  return (
    <Base {...props}>
      <path d="M20 12a8 8 0 0 1-11.6 7.1L4 20l1-4A8 8 0 1 1 20 12Z" />
      <path d="M8.5 10.5h7M8.5 13.5h4.5" />
    </Base>
  );
}
